import whereBuyConstants    from './whereBuy.constants';
import whereBuyInitialState from './whereBuy.state';

function whereBuyReducer(state = whereBuyInitialState, action) {
  switch (action.type) {
    case whereBuyConstants.TRADE_STORE_GET_INITIAL_STATE_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case whereBuyConstants.TRADE_STORE_GET_INITIAL_STATE_SUCCESS:
      state = {
        ...state,
        cities:             action.cities || whereBuyInitialState.cities,
        filter:             action.filter || whereBuyInitialState.filter,
        initialStateLoaded: true,
        items:              action.items || whereBuyInitialState.items,
        loading:            false,
        regionData:         {
          title:           action.regionData.title || whereBuyInitialState.regionData.title,
          description:     action.regionData.description || whereBuyInitialState.regionData.description,
          metaTitle:       action.regionData.metaTitle || whereBuyInitialState.regionData.metaTitle,
          metaDescription: action.regionData.metaDescription || whereBuyInitialState.regionData.metaDescription,
          metaKeywords:    action.regionData.metaKeywords || whereBuyInitialState.regionData.metaKeywords,
          lat:             action.regionData.lat || whereBuyInitialState.regionData.lat,
          lng:             action.regionData.lng || whereBuyInitialState.regionData.lng,
          mapZoom:         action.regionData.mapZoom || whereBuyInitialState.regionData.mapZoom,
        },
        regions:            action.regions || whereBuyInitialState.regions,
        types:              action.types || whereBuyInitialState.types,
      };
      break;

    case whereBuyConstants.TRADE_STORE_GET_INITIAL_STATE_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case whereBuyConstants.TRADE_STORE_FILTER_BY_TYPE:
      state = {
        ...state,
        typeTradeStore: action.typeTradeStore || null,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default whereBuyReducer;